import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
interface CountdownTimerProps {
  initialMinutes?: number;
  onComplete?: () => void;
}
export function CountdownTimer({
  initialMinutes = 15,
  onComplete
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(() => {
    // Check if there's a saved end time in sessionStorage
    const savedEndTime = sessionStorage.getItem('countdownEndTime');
    if (savedEndTime) {
      const remaining = Math.max(0, Math.floor((parseInt(savedEndTime) - Date.now()) / 1000));
      return remaining;
    }
    // Set new end time
    const endTime = Date.now() + initialMinutes * 60 * 1000;
    sessionStorage.setItem('countdownEndTime', endTime.toString());
    return initialMinutes * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) {
      onComplete?.();
      return;
    }
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onComplete?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft, onComplete]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center gap-2" data-id="element-281">
      <Clock className="w-4 h-4 md:w-5 md:h-5 animate-pulse" data-id="element-282" />
      <div className="flex items-center gap-1 font-mono font-bold text-lg md:text-xl" data-id="element-283">
        <span className="bg-white/20 px-2 py-0.5 rounded" data-id="element-284">
          {formatNumber(minutes)}
        </span>
        <span className="animate-pulse" data-id="element-285">:</span>
        <span className="bg-white/20 px-2 py-0.5 rounded" data-id="element-286">
          {formatNumber(seconds)}
        </span>
      </div>
    </div>;
}